import "trix"
import "trix/dist/trix.css"
import "@rails/actiontext"

import Rails from "@rails/ujs"
import * as ActiveStorage from "@rails/activestorage"
import AstronomerPage from "../pages/astronomer_page"
import SessionPage from "../pages/session_page"

import "../packs/application.scss"

Rails.start();
ActiveStorage.start();

window.onload = () => {
  AstronomerPage.initialize();
  SessionPage.initialize();
};
